import { Row } from '../../../../components/row/row';
import { Cell } from '../../../../components/cell/cell';
import { ReadonlyInput } from '../../../../components/readonly-input/readonly-input';
import { AttendanceDataGrid } from './attendance-data-grid';
import { CitizenAttendanceDto } from '../../../../api-service/clients';
import { Content } from '../../../citizen/authority/plan/components/content';

export interface CitizenAttendanceAccordionProps {
  citizen: CitizenAttendanceDto;
}

export function CitizenAttendanceAccordion({ citizen }: CitizenAttendanceAccordionProps) {
  return (
    <Content sx={{ backgroundColor: 'white', padding: 2, borderBottom: '1px solid', borderTop: '1px solid', borderColor: 'divider' }}>
      <Row>
        <Cell size="thirds">
          <ReadonlyInput label="Kontaktperson" value={citizen.contactPerson || '-'} />
        </Cell>
        <Cell size="thirds">
          <ReadonlyInput label="Hold" value={citizen.courseNumber || '-'} />
        </Cell>
        <Cell size="thirds">
          <ReadonlyInput label="Henviser" value={citizen.jobcenterCode || '-'} />
        </Cell>
      </Row>
      <Row>
        <Cell size="full">
          <AttendanceDataGrid rows={citizen.dailyAttendances} />
        </Cell>
      </Row>
    </Content>
  );
}
